export const SuggestionButton = ({handleSuggestionClick, value}) => {
  

  return <input
  onClick={handleSuggestionClick}
  type="button"
  className="button secondary"
  value={value}
/>
}